import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/pay-item-deductions', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/pay-item-deductions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/pay-item-deductions/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/pay-item-deductions/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/pay-item-deductions/${id}`).then(response => Promise.resolve(response.data))
}

export const customRule = (options = {}) => {
  return httpClient
    .get('/api/pay-item-deductions/custom-rules', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, find, update, destroy, customRule }
